const roundToNearest = (nearestInc = 1) => (toRound: number) =>
  Math.round(toRound / nearestInc) * nearestInc;

export const roundToNearest1 = roundToNearest(1);
export const roundToNearestQuarter = roundToNearest(0.25);

export default roundToNearest;
